import styled from '@emotion/styled'
import UploadcareImage from '@uploadcare/nextjs-loader'

const Container = styled.header`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0px 5px -5px 0px ${({ theme }) => theme.colors.lightGray};
  display: flex;
  height: ${({ height }) => height};
  position: fixed;
  width: 100%;
  z-index: 999;
`

const Image = styled.div`
  display: none;
  flex: 0 0 auto;

  ${({ theme }) => theme.media.mUp} {
    display: block;
    margin-bottom: 0;
  }
`

const Logo = styled.a`
  flex: 0 0 110px;
  margin-right: ${({ theme }) => theme.space[2]};
`

const Right = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: right;
`

const Title = styled.a`
  line-height: 16px;
  display: block;
  max-height: 32px;
  text-overflow: ellipsis;
  overflow: hidden;
`

const EmbedHeader = ({ height, list }) => {
  return (
    <Container height={height}>
      <Logo
        className="black f3 fw6 lh-solid ml2 no-underline tracked-tight underline-hover w-20"
        href="https://buymusic.club"
        rel="noopener noreferrer"
        target="_blank"
      >
        Buy Music <br />
        <span className="blue">Club</span>
      </Logo>

      <Right className="tr w-80">
        <h2 className="mr2 mv0 tracked-light">
          <Title
            className="f5 fw6 black no-underline underline-hover"
            href={`/list/${list.slug}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {list.title}
          </Title>
          <div className="f6 fw4">
            by&nbsp;
            <a
              className="blue no-underline underline-hover"
              href={
                list.User ? `/user/${list.User.username}` : `/list/${list.slug}`
              }
              rel="noopener noreferrer"
              target="_blank"
            >
              {list.name}
            </a>
          </div>
        </h2>
      </Right>
      {list.hero_image && (
        <Image alt="list image" className="ml1">
          <UploadcareImage
            height="72"
            quality="80"
            src={list.hero_image + '.jpeg'}
            width="144"
          />
        </Image>
      )}
    </Container>
  )
}

export default EmbedHeader
